// D:\live event\hrexora-frontend-main\src\components\FirstVideo.js

import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";
import introVideo from "../video/INTRO1.mp4";

function FirstVideo() {
  const videoRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {
        // autoplay may fail in rare cases
        console.warn("Autoplay blocked by browser");
      });
    }
  }, []);

  const handleEnded = () => {
    navigate("/login");
  };

  return (
    <div className="intro-container react-background">
      <div className="intro-video-wrapper">
        <video
          ref={videoRef}
          src={introVideo}
          className="intro-video"
          autoPlay        // ✅ autoplay
          playsInline
          onEnded={handleEnded}
          controls={false} // ✅ no controls
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
        />
      </div>
    </div>
  );
}

export default FirstVideo;
